import filters from "./filters";

export default {
  install(Vue) {
    Vue.filter("formatPhoneNumber", filters.formatPhoneNumber);
    Vue.filter("formatMsToDate", filters.formatMilliSecondsToDate);
  }
};



// WEBPACK FOOTER //
// ./src/filters/index.js